// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__Dnl5t","redColor":"style_redColor__ZUGKE","greenColor":"style_greenColor__ILR8P","summaryCell":"style_summaryCell__fs7aM","content":"style_content__aoy2T"};